module.exports = __webpack_public_path__ + "static/media/menu-search-blue.d8faaca5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/menu-search-blue.svg
// module id = 213
// module chunks = 2